<template>
  <div class="mt-20">
    <StickyBtn />
    <!-- Hero -->
    <div
      class="flex w-full bg-cover bg-center h-[80vh]"
      :style="{ backgroundImage: 'url(/img/cw-marketing/hero_forSchool.png)' }"
    />

    <div
      class="flex flex-col items-center justify-start w-full px-12 sm:px-16 lg:px-20 py-20 lg:py-32"
    >
      <div
        class="flex flex-col lg:flex-row w-full max-w-6xl justify-start lg:items-end"
      >
        <div class="w-full lg:w-7/12 lg:order-last">
          <div class="flex flex-col">
            <img
              class="w-full"
              src="/img/cw-marketing/hero_features.png"
              alt="marketing CW image"
            />
          </div>
        </div>
        <div class="w-full lg:w-5/12 pt-12 lg:pr-24 lg:py-0">
          <div class="flex flex-col items-start">
            <h6
              class="font-nunito text-lg mb-4 text-cw-300 uppercase tracking-widest"
            >
              CareerWise
            </h6>
            <h1
              class="font-montserrat text-cw-900 font-black text-4xl sm:text-5xl leading-tight"
            >
              Thoughtfully designed with Career Advisors in mind
            </h1>
            <p class="text-truegray-700 text-left">
              CareerWise is the all-in-one communications platform that bridges
              the gap between career advisors and the universe of career
              pathways.
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Information -->
    <div
      class="flex flex-col items-center justify-center w-full lg:px-20 lg:pb-32"
    >
      <div
        class="flex flex-wrap lg:flex-nowrap w-full max-w-6xl rounded-none lg:rounded-4xl bg-cw-50 shadow-lg relative overflow-hidden"
      >
        <img
          :style="[{ left: '-5%' }, { top: '30%' }]"
          class="absolute w-full lg:w-1/3 opacity-10"
          src="/img/cw-marketing/cw-shapes_dots.svg"
          alt="CW alt shapes"
        />
        <div class="hidden lg:flex justify-center items-center w-1/3 relative">
          <img src="/img/cw-marketing/illu-owl.svg" alt="Illustration CW owl" />
        </div>
        <div
          class="w-full lg:w-2/3 py-20 px-12 sm:px-16 lg:px-20 lg:order-last"
        >
          <div class="flex flex-col items-start relative">
            <h2
              class="font-montserrat font-bold text-3xl sm:text-4xl text-cw-900"
            >
              Imagine having the most comprehensive, up-to-the-minute
              <span class="text-cw-alt font-montserrat">career pathway</span>
              information at your fingertips.
            </h2>
            <p class="mb-0 text-left">
              CareerWise empowers you to guide students and parents with
              confidence, providing instant access to the latest opportunities
              across industries and educational institutions.
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Marketing Stats -->
    <GradientPanel :item="marketingData" />

    <!-- Features -->
    <div
      class="lg:pb-20 flex flex-col items-center justify-center w-full py-32 px-12 sm:px-16 lg:px-20"
    >
      <div
        class="flex flex-col md:flex-row pb-20 sm:pb-24 lg:pb-12 w-full max-w-6xl justify-center items-center"
      >
        <div class="w-full lg:w-5/12">
          <div class="flex flex-col items-start">
            <h2
              class="font-montserrat text-cw-900 font-black text-3xl sm:text-4xl md:text-5xl"
            >
              Simplify your workflow with an all-in-one platform
            </h2>
            <!--
              <p class="text-truegray-700 mb-12 text-left">
              CareerWise makes it easy to curate and share relevant careers
              information directly with students, their parents, and key school
              stakeholders.
              </p> 
            -->
          </div>
        </div>
        <div class="w-full lg:w-7/12 flex md:pl-24">
          <img
            src="/img/cw-marketing/for_schools1.png"
            alt="Illustration simplify"
          />
        </div>
      </div>

      <div
        class="flex flex-col md:flex-row pb-20 sm:pb-24 lg:pb-12 w-full max-w-6xl justify-center items-center"
      >
        <div class="w-full lg:w-5/12 md:order-last">
          <div class="flex flex-col items-start">
            <h2
              class="font-montserrat text-cw-900 font-black text-3xl sm:text-4xl md:text-5xl"
            >
              Take your Careers Team online effortlessly
            </h2>
            <p class="text-truegray-700 mb-12 text-left">
              With CareerWise, your careers website, newsletters, and career
              resources will be effortlessly up to date and constantly
              inspirational.
            </p>
          </div>
        </div>
        <div class="w-full lg:w-7/12 flex md:pr-24">
          <img
            src="/img/cw-marketing/preview_homepage.png"
            alt="Preview Career wise home page"
          />
        </div>
      </div>

      <div
        class="flex flex-col md:flex-row pb-20 sm:pb-24 lg:pb-12 w-full max-w-6xl justify-center items-center"
      >
        <div class="w-full lg:w-5/12">
          <div class="flex flex-col items-start">
            <h2
              class="font-montserrat text-cw-900 font-black text-3xl sm:text-4xl md:text-5xl"
            >
              User-friendly, beautifully designed, and community-driven
            </h2>
            <p class="text-truegray-700 mb-12 text-left">
              CareerWise combines intuitive functionality with curated content
              from the whole Career Advisor community in New Zealand.
            </p>
          </div>
        </div>
        <div class="w-full lg:w-7/12 flex md:pl-24">
          <img
            src="/img/cw-marketing/for_schools3.png"
            alt="Illustration user-friendly"
          />
        </div>
      </div>

      <div
        class="flex flex-col md:flex-row pb-0 w-full max-w-6xl justify-center items-center"
      >
        <div class="w-full lg:w-5/12 md:order-last">
          <div class="flex flex-col items-start">
            <h2
              class="font-montserrat text-cw-900 font-black text-3xl sm:text-4xl md:text-5xl"
            >
              CareerWise handles your heavy lifting
            </h2>
            <p class="text-truegray-700 mb-12 text-left">
              CareerWise takes care of the collection, curation, and
              communicating with students, parents, and stakeholders so that you
              can focus on what matters—providing the best guidance to your
              students.
            </p>
          </div>
        </div>

        <div class="w-full lg:w-7/12 flex md:pr-24">
          <img
            src="/img/cw-marketing/for_schools4.png"
            alt="Preview Career wise home page"
          />
        </div>
      </div>
    </div>

    <!-- CW Advisors -->
    <div
      class="w-full flex flex-col items-center justify-center py-20 lg:py-32 px-12 sm:px-16 lg:px-20 relative overflow-hidden bg-cw-50"
    >
      <div class="w-full lg:w-5/12">
        <h6
          class="font-nunito text-lg mb-4 text-cw-300 uppercase tracking-widest text-center"
        >
          CareerWise Community
        </h6>
        <h1 class="font-montserrat text-cw-900 font-black text-5xl text-center">
          Work Smarter,<br />Not Harder
        </h1>
        <p class="text-center">
          By joining CareerWise you get to collaborate and share information
          with other Career Advisors from all around NZ! We know most Advisors
          receive the same information from tertiary providers and businesses
          etc...so instead of you all making a post about the same thing,
          whoever makes the post first can share it to the Cloud for every other
          advisor to access! Save time and collaborate with the 250+ career
          advisors who use CareerWise.
        </p>
      </div>
    </div>

    <div
      class="pt-24 pb-12 flex flex-col items-center justify-center w-full px-8 lg:px-12"
    >
      <h6
        class="font-nunito text-lg mb-8 text-cw-300 uppercase tracking-widest text-center"
      >
        Meet your community
      </h6>
      <div
        class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 max-w-6xl"
      >
        <!-- Career Advisor images -->
        <img
          v-for="n in 8"
          :key="n"
          class="w-full rounded-4xl shadow-xl h-80"
          :src="`/img/cw-marketing/advisor-${n}.png`"
          alt="Careerwise Advisors"
        />
      </div>
    </div>

    <!-- Success stories -->
    <div
      class="w-full flex flex-col items-center justify-center pt-40 pb-12 px-8 lg:px-12 relative overflow-hidden"
    >
      <img
        :style="[{ right: '-8%' }, { top: '-8%' }]"
        class="absolute w-1/2 lg:w-1/4 opacity-10"
        src="/img/cw-marketing/cw-shapes_dots.svg"
        alt="CW alt shapes"
      />
      <img
        class="h-48 flex-shrink-0 mb-8"
        src="/img/cw-marketing/illu-school.svg"
        alt="CareerWise centeralised service"
      />
      <h6
        class="font-nunito text-lg mb-4 text-cw-300 uppercase tracking-widest"
      >
        Success stories
      </h6>
      <h1 class="font-montserrat text-cw-900 font-black text-5xl text-center">
        Schools
        <span
          class="font-montserrat font-black bg-gradient-to-tr from-pink-600 to-purple-700 bg-clip-text text-transparent"
          >LOVE</span
        ><br />
        CareerWise
      </h1>
    </div>

    <!-- CW testimonial list -->
    <CardGroup :list="testimonials" />

    <!-- School list  -->
    <SchoolList />

    <!-- Pricing -->
    <div
      class="flex flex-col items-center justify-start w-full px-12 sm:px-16 lg:px-20 py-20 lg:py-32 bg-cw-50"
    >
      <div
        class="flex flex-col lg:flex-row w-full max-w-6xl justify-start lg:items-end"
      >
        <div class="w-full lg:w-7/12 pb-12 lg:pr-24">
          <div class="flex flex-col items-start">
            <h1 class="font-montserrat text-cw-900 font-black text-5xl mb-6">
              Let's get started
            </h1>
            <p class="text-truegray-700 text-left mb-2">
              CareerWise is the all-in-one communications platform designed
              specifically for Career Advisors, making it easy to curate and
              share relevant information directly with students, their parents,
              and key school stakeholders.
            </p>

            <p class="text-truegray-700 text-left mb-2">
              With our built-in web and email automation, CareerWise empowers
              you to effortlessly stay connected and look professional, without
              the hassle. 
            </p>

            <div class="flex flex-col gap-4 w-full mt-12">
              <div class="flex flex-col flex-1 items-start">
                <h6
                  class="font-nunito text-lg mb-4 text-cw-300 uppercase tracking-widest"
                >
                  AREA SCHOOLS
                </h6>

                <p class="mb-6">
                  We want CareerWise to be available to all schools, which is
                  why we offer special rates for Area Schools. Enquire about our
                  area school pricing today!
                </p>
                <button
                  class="btn btn-black font-nunito text-md mb-0"
                  @click="toggleCwRegistration(0)"
                >
                  Contact us
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Pricing box -->
        <div
          class="w-full sm:items-end justify-center lg:w-5/12 lg:justify-end flex flex-col sm:flex-row"
        >
          <div
            v-for="(pricing, i) in pricings"
            :key="i"
            class="flex flex-col flex-1 items-start lg:w-max rounded-xl shadow-xl bg-white p-12 mx-auto my-4 sm:ml-4 sm:m-0"
          >
            <h6
              class="font-nunito text-lg mb-4 text-cw-300 uppercase tracking-widest"
            >
              {{ pricing.plan }}
            </h6>
            <div class="flex items-center">
              <h2 class="font-montserrat text-cw-900 font-bold text-5xl">
                ${{ pricing.price.yearly }}
              </h2>
              <p class="pl-4">/year</p>
            </div>
            <button
              :class="pricing.id === 1 ? 'btn-cw-alt' : ''"
              class="btn btn-black font-nunito w-full mb-8"
              @click="toggleCwRegistration(1)"
            >
              Get Started
            </button>
            <div
              class="flex flex-row items-start flex-wrap sm:flex-nowrap sm:gap-8"
            >
              <div class="w-full sm:w-1/2">
                <div
                  v-for="(list, j) in pricing.included1"
                  :key="j"
                  class="flex text-cw-700 items-center mb-2"
                >
                  <svg
                    class="mr-2 w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                  <p class="text-truegray-700 text-left" v-html="list" />
                </div>
              </div>
              <div>
                <div
                  v-for="(list, j) in pricing.included2"
                  :key="j"
                  class="flex text-cw-700 items-center mb-2"
                >
                  <svg
                    class="mr-2 w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                  <p class="text-truegray-700 text-left" v-html="list" />
                </div>
              </div>
            </div>

            <div class="border-t border-cw-300 pt-8 mt-6 w-full">
              <div
                class="bg-truegray-500 text-white rounded-xl p-2 text-center mx-auto w-10/12"
              >
                <template v-if="pricing.id === 0">
                  <p class="text-xs">
                    Newsletter analytics & scheduling / drafting newsletters
                  </p>
                  <p class="text-xs">+ $150</p>
                </template>
                <template v-else>
                  <p class="text-xs">
                    Additional subscriber packs for larger schools.
                  </p>
                  <p class="text-xs">+ $50 per extra 1000 subs</p>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- CTA -->
    <div
      class="flex flex-col items-center justify-center w-full md:py-20 md:px-16"
    >
      <div
        class="flex flex-wrap lg:flex-nowrap w-full max-w-6xl rounded-none md:rounded-4xl bg-black px-12 pt-20 pb-20 lg:pb-0 sm:p-0 text-white relative overflow-hidden"
      >
        <div
          class="w-full lg:w-7/12 relative sm:pb-20 md:pb-0 lg:pb-24 sm:px-24 sm:pt-24"
        >
          <img
            :style="[{ left: '-30%' }, { bottom: '-30%' }]"
            class="absolute w-full lg:w-10/12 opacity-10 filter brightness-0 invert"
            src="/img/cw-marketing/cw-shapes_dots.svg"
            alt="CW alt shapes"
          />
          <div class="flex flex-col items-start relative">
            <h1 class="font-montserrat font-black text-5xl">
              Try first,<br />Decide later.
            </h1>
            <p class="mb-12 text-left">
              Request a trial and one of our team members will reach out to book
              you in for a 30 minute online demo. We‘ll set your site up, show
              you how it works and answer any questions you may have. Then you
              have 2 weeks to use CareerWise and decide if it is right for you.
              No charge!
            </p>
            <button
              class="m-0 btn btn-cw-alt font-nunito shadow-lg"
              @click="toggleCwRegistration(1)"
            >
              Let's get started
            </button>
          </div>
        </div>
        <div class="hidden md:block w-full lg:w-5/12 pt-24 sm:pr-16 lg:pb-0">
          <div class="flex flex-col h-80 lg:h-auto relative">
            <img
              :style="[{ right: '0' }, { top: '0' }]"
              class="w-10/12 lg:w-full absolute"
              src="/img/cw-marketing/cta_mobile_2.png"
              alt="Mobile preview image"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { shared } from '../../../js/mixins/shared.js'
import { EventBus } from '../../../js/plugins/event-bus.js'
import * as loadingAnimation from '../../../shared/components/loading.json'
import SchoolList from '../components/SchoolList.vue'
import CardGroup from '../components/CardGroup.vue'
import StickyBtn from '../components/StickyButton.vue'
import GradientPanel from '../components/GradientPanel.vue'

export default {
  components: {
    StickyBtn,
    SchoolList,
    CardGroup,
    GradientPanel,
  },

  // rounding numbers
  filters: {
    abbr: function (num) {
      if (String(num).length > 6) {
        return Math.round(num / 100000) / 10 + 'M'
      } else {
        if (String(num).length > 3) {
          return Math.round(num / 1000) + 'K'
        }
        return num
      }
    },
  },

  mixins: [shared],

  data() {
    return {
      marketingData: {
        title:
          'Join a vibrant community of more than 300+ career advisors from all across New Zealand. ',
        text: null,
        buttonText: null,
        image: null,
        stats: [
          {
            name: 'Career Advisors',
            numbers: 300,
          },
          {
            name: 'Students',
            numbers: 139000,
          },
          {
            name: 'Career Posts',
            numbers: 3000,
          },
        ],
      },

      /* CW testimonials */
      testimonials: [
        {
          longtext:
            'There is so much careers information available for students I was looking for a way to make this information easily accessible to students in one location. The careerwise website is the perfect solution for me. It is easy to use for a non-tech savvy person, easy to keep up to date and I love having access to the Hub posts from other schools or providers, which I can easily add to my website. The support from the careerwise staff if I do something silly (like accidentally delete an entire page of information) is timely and excellent too.',
          logo: '/img/cw-marketing/testimonials_UHC.png',
          name: 'Kerry Weston',
          school: 'Upper Hutt College',
        },
        {
          longtext:
            'CareerWise is a one stop tool for our kura. Easy to use and professional, this is where we can post up to date information on key events and share post from other kura. Having the ability to generate careers newsletter is easy. Having providers and tertiary institutions on board can also save time for careers staff, no more sending emails to students ! I would highly recommend CareerWise for your kura. With great support from the CareerWise team you cant go wrong.',
          logo: '/img/cw-marketing/testimonials_CCC.png',
          name: 'Danielle Herrick',
          school: 'Catholic Cathedral College',
        },
        {
          longtext:
            "I love my CareerWise site! It is a critical tool which I use every day in my role as Careers Pathways Advisor at St Margaret's College. The site helps me to keep track of the vast range of awesome career exploration opportunities, events & news that arrive in my inbox each week and to communicate these with ease to our school community. All our Year 11-13 students subscribe to the weekly careers newsletter, as do interested staff and parents. It's so useful to have a 'one-stop-shop' for career exploration tools and resources. When I began this role, the first thing I wanted to create was a website to store and share such events and information, and I was so glad to learn that one already existed in the form of CareerWise. The team are always willing to listen to the needs of their users, adding improvements and keeping the look of the website fresh.",
          logo: '/img/cw-marketing/testimonials_SMC.png',
          name: 'Jenni Mclaughlin',
          school: "St Margaret's College",
        },
        {
          longtext:
            "Our school has used careerwise for the last two years. I've found careerwise to be an awesome platform to establish our careers website. The website is easy to administer and each year there are improvements to the site and ongoing developments that make our job easier. The students find the website easy to navigate and enjoy the newsletter that is emailed to them each week. Careerwise are quick to answer any questions that I have.",
          logo: '/img/cw-marketing/testimonials_WD.png',
          name: 'Sue Wylie',
          school: 'Waikato Diocesan',
        },
        {
          longtext:
            'Having a Careerwise website has made the sharing of careers information both easier and clearer. Students know where to go for information either on their laptops or phones. The website is easy to organise and update; there are many tools to make these processes easy and support is quickly provided. A website is an effective way in which to retain information which rolls over from year to year, such as application guidelines, while also allowing for current news, jobs and events to be communicated. I highly recommend using a Careerwise website.',
          logo: '/img/cw-marketing/testimonials_IC.png',
          name: 'Cathy Blake',
          school: 'Iona College',
        },
        {
          longtext:
            'We have found careerwise to be a simple and easy platform to use, it is a streamlined way for our kura to make connections across our whole community. The feedback from ākonga, whānau and kaiako has been overwhelmingly positive.',
          logo: '/img/cw-marketing/testimonials_PNGHS.png',
          name: 'Donna Manley',
          school: "Palmerston North Girls' High School",
        },
      ],

      pricings: [
        {
          id: 1,
          plan: 'CareerWise',
          price: { yearly: 999, monthly: 89 },
          included1: [
            'Free setup and training',
            'Cloud access',
            'Custom themes',
            'Advanced analytics',
            'TV mode',
          ],

          included2: [
            'Save & schedule newsletters',
            '6000 subscribers',
            'Newsletter open & click stats',
            'Guest author library pages',
          ],
        },
      ],

      loadingAnimationOptions: { animationData: loadingAnimation.default },
      loadingAnimate: false,
    }
  },

  methods: {
    // Type of enquiry; 0 === information, 1 === demo, 2 === sign up, 3 === upgrade plan, 4 === other, 5 === Hail
    toggleCwRegistration(type) {
      EventBus.$emit('showModal', 'cw-registration')
      setTimeout(() => {
        EventBus.$emit('new_reason', type)
      }, 50)
    },
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@700;900&display=swap');
</style>
